/**
 * PDP Swiper Media Gallery Initialization - Love Knots
 */
function initPdpSwiper() {
  if (typeof Swiper === 'undefined') {
    setTimeout(initPdpSwiper, 100);
    return;
  }

  const galleryWrappers = document.querySelectorAll('.pdp-gallery-swiper-wrapper');

  galleryWrappers.forEach((wrapper) => {
    const sectionId = wrapper.dataset.sectionId;
    const mainEl = wrapper.querySelector(`.pdp-main-swiper`);
    const thumbsEl = wrapper.querySelector(`.pdp-thumbs-swiper`);

    if (!mainEl) return;

    // Destroy existing instances if reloading
    if (mainEl.swiper) {
      mainEl.swiper.destroy(true, true);
    }
    if (thumbsEl && thumbsEl.swiper) {
      thumbsEl.swiper.destroy(true, true);
    }

    // 1. Initialize Thumbs Swiper (Shows 4 thumbnails at a time)
    let thumbsSwiperInstance = null;
    if (thumbsEl) {
      thumbsSwiperInstance = new Swiper(thumbsEl, {
        spaceBetween: 10,
        slidesPerView: 4,
        freeMode: false,
        watchSlidesProgress: true,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: wrapper.querySelector('.pdp-thumb-next'),
          prevEl: wrapper.querySelector('.pdp-thumb-prev'),
        },
        breakpoints: {
          320: {
            slidesPerView: 4,
            spaceBetween: 8,
          },
          750: {
            slidesPerView: 4,
            spaceBetween: 10,
          },
          990: {
            slidesPerView: 4,
            spaceBetween: 12,
          },
        },
      });
    }

    // 2. Initialize Main Swiper
    const paginationEl = wrapper.querySelector('.pdp-swiper-pagination');
    const mainSwiperInstance = new Swiper(mainEl, {
      spaceBetween: 12,
      slidesPerView: 1,
      speed: 550,
      grabCursor: true,
      observer: true,
      observeParents: true,
      navigation: {
        nextEl: wrapper.querySelector('.pdp-swiper-next'),
        prevEl: wrapper.querySelector('.pdp-swiper-prev'),
      },
      pagination: paginationEl ? {
        el: paginationEl,
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + ' pdp-swiper-dash" aria-label="Slide ' + (index + 1) + '"></span>';
        },
      } : false,
      thumbs: thumbsSwiperInstance ? {
        swiper: thumbsSwiperInstance,
      } : undefined,
    });

    // 3. Variant Image Synchronization
    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        if (event.data.sectionId !== sectionId) return;
        const variant = event.data.variant;
        if (!variant || !variant.featured_media) return;

        const targetMediaId = `${sectionId}-${variant.featured_media.id}`;
        const slides = mainEl.querySelectorAll('.swiper-slide');
        let targetIndex = -1;

        slides.forEach((slide, index) => {
          if (slide.dataset.mediaId === targetMediaId) {
            targetIndex = index;
          }
        });

        if (targetIndex >= 0) {
          mainSwiperInstance.slideTo(targetIndex);
        }
      });
    }

    // 4. Initialize Fancybox with Minimal, Clean Lightbox & Zoom
    function setupFancybox(retries = 10) {
      if (typeof Fancybox === 'undefined') {
        if (retries > 0) setTimeout(() => setupFancybox(retries - 1), 100);
        return;
      }
      Fancybox.unbind(`[data-fancybox="gallery-${sectionId}"]`);
      Fancybox.bind(`[data-fancybox="gallery-${sectionId}"]`, {
        Toolbar: {
          display: {
            left: ['infobar'],
            middle: [],
            right: ['iterateZoom', 'thumbs', 'close'],
          },
        },
        Thumbs: {
          showOnStart: true,
          type: 'classic',
        },
        Images: {
          zoom: true,
          Panzoom: {
            maxScale: 3,
          },
        },
        Carousel: {
          infinite: false,
          transition: 'fade',
        },
        dragToClose: true,
        on: {
          'Carousel.change': (fancybox, carousel, to) => {
            if (mainSwiperInstance) {
              mainSwiperInstance.slideTo(to);
            }
          },
        },
      });
    }
    setupFancybox();
  });
}

/**
 * Aligns Add-To-Cart and GoKwik Buy Now buttons side-by-side on desktop
 */
function initPdpActionButtons() {
  const containers = document.querySelectorAll('.product__info-container');

  containers.forEach((container) => {
    function tryGrouping() {
      const productForm = container.querySelector('product-form, .product-form');
      if (!productForm) return;

      // Find the direct block wrapper for Add-to-Cart
      let formBlock = productForm.closest('div[id^="shopify-block-"]') || productForm.closest('.product-form-container') || productForm.parentElement;
      if (!formBlock) return;
      while (formBlock.parentElement && formBlock.parentElement !== container) {
        formBlock = formBlock.parentElement;
      }
      if (formBlock.parentElement !== container) return;

      // Find GoKwik block container
      const kwikElements = container.querySelectorAll('[class*="kwik"], [id*="kwik"], [class*="gokwik"], [id*="gokwik"], [data-gokwik], [onclick*="gokwik"], .gokwik-checkout, #gokwik-buy-now, [id*="kwik_cod_checkout"]');

      let kwikBlock = null;
      for (let el of kwikElements) {
        if (productForm.contains(el)) continue;
        let candidate = el.closest('div[id^="shopify-block-"]') || el;
        while (candidate && candidate.parentElement && candidate.parentElement !== container) {
          candidate = candidate.parentElement;
        }
        if (candidate && candidate.parentElement === container && candidate !== formBlock) {
          kwikBlock = candidate;
          break;
        }
      }

      // Fallback: check next direct sibling of formBlock if it contains a button or iframe
      if (!kwikBlock && formBlock.nextElementSibling) {
        const next = formBlock.nextElementSibling;
        if (next.querySelector('button, iframe, a, [class*="kwik"], [class*="gokwik"], [class*="buy-now"]') || next.classList.contains('shopify-app-block')) {
          kwikBlock = next;
        }
      }

      if (formBlock && kwikBlock && formBlock !== kwikBlock && formBlock.parentElement === container && kwikBlock.parentElement === container) {
        if (formBlock.parentElement.classList.contains('pdp-action-buttons-row')) return;

        const row = document.createElement('div');
        row.className = 'pdp-action-buttons-row';
        formBlock.parentNode.insertBefore(row, formBlock);
        row.appendChild(formBlock);
        row.appendChild(kwikBlock);
      }
    }

    tryGrouping();

    // Observe asynchronous GoKwik button injections
    if (window.MutationObserver && !container._pdpActionObserverAttached) {
      container._pdpActionObserverAttached = true;
      const observer = new MutationObserver(() => {
        tryGrouping();
      });
      observer.observe(container, { childList: true, subtree: true });
    }
  });
}

/**
 * Combines Judge.me stars and Sell Count badge into a single inline flex row
 * and formats review count text from "X reviews" to "(X)"
 */
function initPdpRatingSellRow() {
  const containers = document.querySelectorAll('.product__info-container');

  containers.forEach((container) => {
    function tryRowGrouping() {
      const starsBlock = container.querySelector('.product__judgeme-stars');
      const sellBlock = container.querySelector('.product__sell-count');

      // Format review count to "(X)"
      if (starsBlock) {
        const prevBadge = starsBlock.querySelector('.jdgm-prev-badge');
        if (prevBadge) {
          const textEl = prevBadge.querySelector('.jdgm-prev-badge__text');
          const count = prevBadge.getAttribute('data-number-of-reviews') || (textEl ? textEl.textContent.replace(/[^\d]/g, '') : '');
          if (textEl && count && textEl.textContent !== `(${count})`) {
            textEl.textContent = `(${count})`;
          }
        }
      }

      if (starsBlock && sellBlock && starsBlock !== sellBlock) {
        let starDirect = starsBlock.closest('div[id^="shopify-block-"]') || starsBlock;
        while (starDirect && starDirect.parentElement && starDirect.parentElement !== container && !starDirect.parentElement.classList.contains('product__rating-sell-row')) {
          starDirect = starDirect.parentElement;
        }

        let sellDirect = sellBlock.closest('div[id^="shopify-block-"]') || sellBlock;
        while (sellDirect && sellDirect.parentElement && sellDirect.parentElement !== container && !sellDirect.parentElement.classList.contains('product__rating-sell-row')) {
          sellDirect = sellDirect.parentElement;
        }

        if (starDirect && sellDirect && starDirect.parentElement === container && sellDirect.parentElement === container) {
          if (starDirect.parentElement.classList.contains('product__rating-sell-row')) return;

          const row = document.createElement('div');
          row.className = 'product__rating-sell-row';
          starDirect.parentNode.insertBefore(row, starDirect);
          row.appendChild(starDirect);
          row.appendChild(sellDirect);
        }
      }
    }

    tryRowGrouping();

    if (window.MutationObserver && !container._pdpRatingObserverAttached) {
      container._pdpRatingObserverAttached = true;
      const observer = new MutationObserver(() => {
        tryRowGrouping();
      });
      observer.observe(container, { childList: true, subtree: true, characterData: true });
    }
  });
}

// Global listener for Judge.me initialization
document.addEventListener('jdgm.doneSetup', () => {
  initPdpRatingSellRow();
});

// Run on page load and DOMReady
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initPdpSwiper();
    initPdpActionButtons();
    initPdpRatingSellRow();
  });
} else {
  initPdpSwiper();
  initPdpActionButtons();
  initPdpRatingSellRow();
}

// Re-initialize on theme editor section updates
if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    initPdpSwiper();
    initPdpActionButtons();
    initPdpRatingSellRow();
  });
}


